import React from 'react';
import { Box, Typography, Divider } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import CustomChip from '../../Components/CustomChip';
import { CustomButton } from '../../../v2/MUI_custom_component';
import { toCapitalized } from '../../../v2/Utils/Capitalize';


const RoleStep = () => {
  const dispatch = useDispatch();
  const { vcpRoles, influencerRoles, isInfluencerSelected, selectedRole } =
    useSelector((state) => state.onboardBuyerReducer);

  const hasInfluencerRoles = influencerRoles.length > 0;

  const handleVcpClick = (role) => {
    dispatch({ type: 'SELECT_VCP_ROLE', payload: role });
  };

  const handleInfluencerToggle = (open) => {
    dispatch({ type: 'TOGGLE_INFLUENCER', payload: open });
  };

  const handleInfluencerRoleClick = (role) => {
    dispatch({ type: 'SELECT_INFLUENCER_ROLE', payload: role });
  };

  const clearSelectedRole = () => {
    dispatch({ type: 'CLEAR_SELECTED_ROLE' });
  };

  const handleContinue = () => {
    dispatch({ type: 'SET_ONBOARD_ACTIVE_STEP', payload: 1 });
  };

  const isRoleSelected = (role) =>
    selectedRole?.firm_role_id === role.firm_role_id;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        width: "100%",
        gap: { xs: 2, md: 8 },
        minHeight: { xs: "65vh", md: "auto" },
      }}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: 2,
          width: "100%",
          flex: 1,
        }}>
        <Typography
          variant="h2"
          sx={{
            color: "#333333",
            textAlign: "center",
          }}>
          What is the role of the buyer?
        </Typography>
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            gap: 1,
            width: "100%",
          }}>
          {vcpRoles?.map((role) => {
            const selected = !isInfluencerSelected && isRoleSelected(role);
            return (
              <CustomChip
                key={role.firm_role_id}
                label={toCapitalized(role.display_name)}
                variant="filled"
                selected={selected}
                onClick={() => handleVcpClick(role)}
                onDelete={selected ? clearSelectedRole : undefined}
              />
            );
          })}

          {hasInfluencerRoles && (
            <CustomChip
              label="Influencer"
              variant="filled"
              selected={isInfluencerSelected}
              onClick={() => handleInfluencerToggle(true)}
              onDelete={
                isInfluencerSelected
                  ? () => handleInfluencerToggle(false)
                  : undefined
              }
            />
          )}
        </Box>
        {isInfluencerSelected && hasInfluencerRoles && (
          <>
            <Divider sx={{ width: "302px", borderColor: "#8C8C8C" }} />
            <Box
              sx={{
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "center",
                gap: 1,
                width: "100%",
              }}>
              {influencerRoles.map((role) => {
                const selected = isRoleSelected(role);
                return (
                  <CustomChip
                    key={role.firm_role_id}
                    label={toCapitalized(role.display_name)}
                    variant="filled"
                    selected={selected}
                    onClick={() => handleInfluencerRoleClick(role)}
                    onDelete={selected ? clearSelectedRole : undefined}
                  />
                );
              })}
            </Box>
          </>
        )}
      </Box>
      {selectedRole && (
        <Box sx={{ width: "616px", maxWidth: "100%" }}>
          <CustomButton label="Continue" fullWidth onClick={handleContinue} />
        </Box>
      )}
    </Box>
  );
};

export default RoleStep;
